import { TOGGLE_BLOCK_TABLE_HISTORY_BUTTON } from './constants'

export function toggleHistoryButton(tableId, buttonId) {
    return {
        type: TOGGLE_BLOCK_TABLE_HISTORY_BUTTON,
        data: {
            tableId,
            buttonId,
        },
    }
}
